import { render, staticRenderFns } from "./EventReport.vue?vue&type=template&id=f2e80044&"
import script from "./EventReport.vue?vue&type=script&lang=js&"
export * from "./EventReport.vue?vue&type=script&lang=js&"
import style0 from "./EventReport.vue?vue&type=style&index=0&id=f2e80044&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QTabs,QTab,QTabPanels,QTabPanel,QSeparator,QSelect,QBtn,QSkeleton,QCard,QCardSection,QIcon,QTooltip,QTable,QInnerLoading,QSpinnerTail} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QTabs,QTab,QTabPanels,QTabPanel,QSeparator,QSelect,QBtn,QSkeleton,QCard,QCardSection,QIcon,QTooltip,QTable,QInnerLoading,QSpinnerTail})
